// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableSortLabel,
//   Avatar,
//   Tabs,
//   Tab,
//   TableContainer,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   People as PeopleIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   Person as PersonIcon,
//   Work as WorkIcon,
//   Phone as PhoneIcon,
//   Email as EmailIcon,
//   LocationOn as LocationIcon,
//   AccountBalance as BankIcon,
//   School as EducationIcon,
//   Event as DateIcon,
//   AttachMoney as MoneyIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const EmployeesPage = () => {
//   const navigate = useNavigate();
//   const [employees, setEmployees] = useState([]);
//   const [filteredEmployees, setFilteredEmployees] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [options, setOptions] = useState({
//     departments: [],
//     positions: [],
//     employment_statuses: [],
//     employment_types: [],
//     genders: [],
//     shifts: [],
//     work_schedules: []
//   });
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     department: "",
//     position: "",
//     employment_status: "",
//     employment_type: ""
//   });

//   // Dialogs
//   const [showFilters, setShowFilters] = useState(false);
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [activeTab, setActiveTab] = useState(0);

//   // Form Data
//   const [employeeForm, setEmployeeForm] = useState({
//     employee_id: "",
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone_number: "",
//     date_of_birth: "",
//     gender: "",
//     national_id: "",
//     job_title: "",
//     department: "",
//     employment_type: "Full-time",
//     employment_status: "Active",
//     hire_date: "",
//     salary: "",
//     address_line1: "",
//     address_line2: "",
//     city: "",
//     state: "",
//     postal_code: "",
//     country: "",
//     emergency_contact_name: "",
//     emergency_contact_phone: "",
//     emergency_contact_relationship: "",
//     bank_name: "",
//     bank_account_number: "",
//     bank_routing_number: "",
//     education_level: "",
//     qualifications: "",
//     certifications: "",
//     work_schedule: "",
//     shift: "",
//     performance_rating: "",
//     last_performance_review: "",
//     next_review_date: "",
//     vacation_days_remaining: "",
//     sick_days_remaining: "",
//     personal_days_remaining: "",
//     supervisor_name: "",
//     notes: ""
//   });

//   // Table Columns for Virtualized Table - Removed department and salary columns
//   const columns = [
//     { width: 60, label: 'Avatar', dataKey: 'avatar' },
//     { width: 120, label: 'Employee ID', dataKey: 'employee_id' },
//     { width: 150, label: 'Full Name', dataKey: 'full_name' },
//     { width: 150, label: 'Email', dataKey: 'email' },
//     { width: 120, label: 'Phone', dataKey: 'phone_number' },
//     { width: 120, label: 'Position', dataKey: 'job_title' },
//     { width: 120, label: 'Status', dataKey: 'employment_status' },
//     { width: 150, label: 'Actions', dataKey: 'actions' },
//   ];

//   const API_URL = "https://dairy.server.statify.co.ke/api/employees";

//   // Helper function to calculate age from date of birth
//   const calculateAge = (dateOfBirth) => {
//     if (!dateOfBirth) return 0;
//     const today = new Date();
//     const birthDate = new Date(dateOfBirth);
//     let age = today.getFullYear() - birthDate.getFullYear();
//     const monthDiff = today.getMonth() - birthDate.getMonth();
    
//     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
//       age--;
//     }
    
//     return age;
//   };

//   // Helper function to validate age (must be 12 years and above)
//   const validateAge = (dateOfBirth) => {
//     const age = calculateAge(dateOfBirth);
//     return age >= 12;
//   };

//   // Helper function to sanitize form data before sending to backend
//   const sanitizeFormData = (data) => {
//     const sanitized = {};
    
//     // Process each field individually
//     Object.keys(data).forEach(key => {
//       let value = data[key];
      
//       // Convert empty strings, "None", "N/A" to null
//       if (value === "" || value === "None" || value === "N/A") {
//         value = null;
//       }
      
//       // Handle date fields specifically
//       const dateFields = ['date_of_birth', 'hire_date', 'last_performance_review', 'next_review_date'];
//       if (dateFields.includes(key)) {
//         if (value) {
//           try {
//             const date = new Date(value);
//             if (!isNaN(date.getTime())) {
//               sanitized[key] = date.toISOString().split('T')[0]; // YYYY-MM-DD format
//             } else {
//               sanitized[key] = null;
//             }
//           } catch {
//             sanitized[key] = null;
//           }
//         } else {
//           sanitized[key] = null;
//         }
//       }
//       // Handle number fields
//       else if (['salary', 'performance_rating', 'vacation_days_remaining', 'sick_days_remaining', 'personal_days_remaining'].includes(key)) {
//         if (value && !isNaN(parseFloat(value))) {
//           sanitized[key] = parseFloat(value);
//         } else {
//           sanitized[key] = null;
//         }
//       }
//       // Handle all other fields
//       else {
//         sanitized[key] = value;
//       }
//     });

//     return sanitized;
//   };

//   // Fetch Employees
//   const fetchEmployees = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
      
//       if (data && Array.isArray(data.employees)) {
//         // Transform data to include full name and formatted values
//         const transformedEmployees = data.employees.map(employee => ({
//           ...employee,
//           full_name: `${employee.first_name} ${employee.last_name}`,
//           salary: employee.salary ? `$${parseFloat(employee.salary).toLocaleString()}` : 'N/A',
//           hire_date: employee.hire_date ? new Date(employee.hire_date).toLocaleDateString() : 'N/A',
//           date_of_birth: employee.date_of_birth ? new Date(employee.date_of_birth).toLocaleDateString() : 'N/A',
//           avatar_color: getAvatarColor(employee.first_name),
//           phone_number: employee.phone_number || 'N/A',
//           email: employee.email || 'N/A',
//           department: employee.department || 'N/A',
//           job_title: employee.job_title || 'N/A',
//           employment_status: employee.employment_status || 'Active'
//         }));
//         setEmployees(transformedEmployees);
//         setFilteredEmployees(transformedEmployees);
//       } else {
//         setEmployees([]);
//         setFilteredEmployees([]);
//       }
//     } catch (err) {
//       console.error('Error fetching employees:', err);
//       swal("Error", "Failed to fetch employees", "error");
//       setEmployees([]);
//       setFilteredEmployees([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch Options
//   // Fetch Options
// const fetchOptions = async () => {
//   try {
//     const res = await fetch(`${API_URL}/options`);
//     if (!res.ok) {
//       throw new Error(`HTTP error! status: ${res.status}`);
//     }
//     const data = await res.json();
//     if (data) {
//       setOptions(data);
//     } else {
//       throw new Error('No data received');
//     }
//   } catch (err) {
//     console.error('Error fetching options:', err);
//     // Use comprehensive default options
//     setOptions({
//       departments: [
//         "Milking Department", "Dairy Operations", "Animal Husbandry", 
//         "Feed & Nutrition", "Veterinary Services", "Breeding & Genetics",
//         "Quality Assurance", "Processing & Packaging", "Maintenance & Engineering",
//         "Logistics & Distribution", "Human Resources", "Finance & Administration",
//         "Procurement", "Sales & Marketing", "Health, Safety & Environment", 
//         "IT & Data Management"
//       ],
//       positions: [
//         // Operations & Production
//         "Chief Dairy Officer", "Dairy Farm Manager", "Assistant Dairy Manager",
//         "Milking Supervisor", "Senior Milker", "Milker", "Junior Milker",
//         "Milking Technician", "Processing Supervisor", "Pasteurization Operator",
//         "Packaging Operator", "Quality Control Technician",
//         // Animal Husbandry & Vet
//         "Herd Manager", "Livestock Supervisor", "Veterinarian", "Veterinary Assistant",
//         "Animal Health Technician", "Feed Supervisor", "Nutrition Specialist",
//         "Breeding Officer", "Artificial Insemination Technician",
//         // Maintenance & Logistics
//         "Maintenance Engineer", "Equipment Technician", "Electrician", "Plumber",
//         "Logistics Officer", "Transport Coordinator", "Driver", "Warehouse Clerk",
//         // Admin & Support
//         "HR Manager", "HR Assistant", "Finance Manager", "Accountant",
//         "Procurement Officer", "Inventory Clerk", "Administrative Assistant",
//         "IT Officer", "Data Analyst", "Safety Officer", "Marketing Officer",
//         "Sales Representative"
//       ],
//       employment_statuses: ["Active", "Inactive"],
//       employment_types: ["Full-time", "Part-time", "Contract", "Seasonal"],
//       genders: ["Male", "Female", "Other"],
//       shifts: ["Morning Shift", "Afternoon Shift", "Evening Shift", "Night Shift", "Rotating Shift"],
//       work_schedules: ["5-day week", "6-day week", "Rotating", "Flexible"]
//     });
//   }
// };
//   useEffect(() => {
//     fetchEmployees();
//     fetchOptions();
//   }, []);

//   // Filter employees based on search and filters
//   useEffect(() => {
//     if (!Array.isArray(employees)) {
//       setFilteredEmployees([]);
//       return;
//     }
    
//     let results = employees;

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(employee =>
//         (employee.employee_id?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (employee.first_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (employee.last_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (employee.email?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (employee.department?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (employee.job_title?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (employee.phone_number?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply filters
//     if (filters.department) {
//       results = results.filter(employee => 
//         employee.department === filters.department
//       );
//     }

//     if (filters.position) {
//       results = results.filter(employee => 
//         employee.job_title === filters.position
//       );
//     }

//     if (filters.employment_status) {
//       results = results.filter(employee => 
//         employee.employment_status === filters.employment_status
//       );
//     }

//     if (filters.employment_type) {
//       results = results.filter(employee => 
//         employee.employment_type === filters.employment_type
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredEmployees(results);
//   }, [employees, searchTerm, filters, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       department: "",
//       position: "",
//       employment_status: "",
//       employment_type: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   // Form Handlers
//   const handleFormChange = (field, value) => {
//     setEmployeeForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const resetForm = () => {
//     setEmployeeForm({
//       employee_id: "",
//       first_name: "",
//       last_name: "",
//       email: "",
//       phone_number: "",
//       date_of_birth: "",
//       gender: "",
//       national_id: "",
//       job_title: "",
//       department: "",
//       employment_type: "Full-time",
//       employment_status: "Active",
//       hire_date: "",
//       salary: "",
//       address_line1: "",
//       address_line2: "",
//       city: "",
//       state: "",
//       postal_code: "",
//       country: "",
//       emergency_contact_name: "",
//       emergency_contact_phone: "",
//       emergency_contact_relationship: "",
//       bank_name: "",
//       bank_account_number: "",
//       bank_routing_number: "",
//       education_level: "",
//       qualifications: "",
//       certifications: "",
//       work_schedule: "",
//       shift: "",
//       performance_rating: "",
//       last_performance_review: "",
//       next_review_date: "",
//       vacation_days_remaining: "",
//       sick_days_remaining: "",
//       personal_days_remaining: "",
//       supervisor_name: "",
//       notes: ""
//     });
//   };

//   // Create Employee
//   const handleCreateEmployee = async () => {
//     // Validation
//     if (!employeeForm.first_name || !employeeForm.last_name) {
//       swal("Error", "First name and last name are required", "error");
//       return;
//     }

//     // Age validation - must be 12 years and above
//     if (employeeForm.date_of_birth) {
//       const age = calculateAge(employeeForm.date_of_birth);
//       if (age < 12) {
//         swal("Error", "Employee must be 12 years or older. Current age would be " + age + " years.", "error");
//         return;
//       }
//     }

//     try {
//       const sanitizedData = sanitizeFormData(employeeForm);
//       console.log("Sending data:", sanitizedData); // Debug log
      
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(sanitizedData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Employee created successfully!", "success");
//         setOpenCreateDialog(false);
//         resetForm();
//         setActiveTab(0);
//         fetchEmployees();
//       } else {
//         swal("Error", data.error || "Failed to create employee", "error");
//       }
//     } catch (err) {
//       console.error("Create employee error:", err);
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Update Employee
//   const handleUpdateEmployee = async () => {
//     if (!selectedEmployee) return;

//     // Age validation - must be 12 years and above
//     if (employeeForm.date_of_birth) {
//       const age = calculateAge(employeeForm.date_of_birth);
//       if (age < 12) {
//         swal("Error", "Employee must be 12 years or older. Current age would be " + age + " years.", "error");
//         return;
//       }
//     }

//     try {
//       const sanitizedData = sanitizeFormData(employeeForm);
//       console.log("Updating data:", sanitizedData); // Debug log
      
//       const res = await fetch(`${API_URL}/${selectedEmployee.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(sanitizedData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Employee updated successfully!", "success");
//         setOpenEditDialog(false);
//         setSelectedEmployee(null);
//         resetForm();
//         setActiveTab(0);
//         fetchEmployees();
//       } else {
//         swal("Error", data.error || "Failed to update employee", "error");
//       }
//     } catch (err) {
//       console.error("Update employee error:", err);
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (employeeId) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the employee record!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${employeeId}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchEmployees();
//         } else {
//           swal("Error", data.error || "Failed to delete employee", "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // View Employee Details
//   const handleViewDetails = (employee) => {
//     setSelectedEmployee(employee);
//     setOpenViewDialog(true);
//   };

//   // Format date for form input (YYYY-MM-DD)
//   const formatDateForInput = (dateString) => {
//     if (!dateString || dateString === 'N/A') return "";
//     try {
//       const date = new Date(dateString);
//       return date.toISOString().split('T')[0];
//     } catch {
//       return "";
//     }
//   };

//   // Open Edit Dialog
//   const handleEdit = (employee) => {
//     setSelectedEmployee(employee);
//     setEmployeeForm({
//       employee_id: employee.employee_id || "",
//       first_name: employee.first_name || "",
//       last_name: employee.last_name || "",
//       email: employee.email || "",
//       phone_number: employee.phone_number || "",
//       date_of_birth: formatDateForInput(employee.date_of_birth),
//       gender: employee.gender || "",
//       national_id: employee.national_id || "",
//       job_title: employee.job_title || "",
//       department: employee.department || "",
//       employment_type: employee.employment_type || "Full-time",
//       employment_status: employee.employment_status || "Active",
//       hire_date: formatDateForInput(employee.hire_date),
//       salary: employee.salary ? employee.salary.replace('$', '').replace(/,/g, '') : "",
//       address_line1: employee.address_line1 || "",
//       address_line2: employee.address_line2 || "",
//       city: employee.city || "",
//       state: employee.state || "",
//       postal_code: employee.postal_code || "",
//       country: employee.country || "",
//       emergency_contact_name: employee.emergency_contact_name || "",
//       emergency_contact_phone: employee.emergency_contact_phone || "",
//       emergency_contact_relationship: employee.emergency_contact_relationship || "",
//       bank_name: employee.bank_name || "",
//       bank_account_number: employee.bank_account_number || "",
//       bank_routing_number: employee.bank_routing_number || "",
//       education_level: employee.education_level || "",
//       qualifications: employee.qualifications || "",
//       certifications: employee.certifications || "",
//       work_schedule: employee.work_schedule || "",
//       shift: employee.shift || "",
//       performance_rating: employee.performance_rating || "",
//       last_performance_review: formatDateForInput(employee.last_performance_review),
//       next_review_date: formatDateForInput(employee.next_review_date),
//       vacation_days_remaining: employee.vacation_days_remaining || "",
//       sick_days_remaining: employee.sick_days_remaining || "",
//       personal_days_remaining: employee.personal_days_remaining || "",
//       supervisor_name: employee.supervisor_name || "",
//       notes: employee.notes || ""
//     });
//     setOpenEditDialog(true);
//   };

//   // Get Status Color
//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'active': return 'success';
//       case 'inactve': return 'warning';
//       case 'terminated': return 'error';
//       case 'retired': return 'secondary';
//       case 'suspended': return 'error';
//       case 'probation': return 'warning';
//       default: return 'default';
//     }
//   };

//   // Get Avatar Color
//   const getAvatarColor = (name) => {
//     const colors = [
//       '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5',
//       '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50',
//       '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800'
//     ];
//     const index = name ? name.charCodeAt(0) % colors.length : 0;
//     return colors[index];
//   };

//   // Generate Avatar
//   const generateAvatar = (employee) => {
//     const initials = `${employee.first_name?.[0] || ''}${employee.last_name?.[0] || ''}`.toUpperCase();
//     return (
//       <Avatar
//         sx={{
//           bgcolor: employee.avatar_color || getAvatarColor(employee.first_name),
//           width: 32,
//           height: 32,
//           fontSize: '0.875rem'
//         }}
//       >
//         {initials}
//       </Avatar>
//     );
//   };

//   // Format date for display
//   const formatDate = (dateString) => {
//     if (!dateString || dateString === 'N/A') return 'N/A';
//     try {
//       return new Date(dateString).toLocaleDateString();
//     } catch {
//       return dateString;
//     }
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'primary.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, employee) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         {generateAvatar(employee)}
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {employee.employee_id || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {employee.full_name}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {employee.email}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {employee.phone_number}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {employee.job_title}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={employee.employment_status} 
//           size="small"
//           color={getStatusColor(employee.employment_status)}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="info"
//             onClick={() => handleViewDetails(employee)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleEdit(employee)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(employee.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   // Form Tabs Content
//   const renderFormTabContent = () => {
//     switch (activeTab) {
//       case 0: // Basic Info
//         return (
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Employee ID"
//                 value={employeeForm.employee_id}
//                 onChange={(e) => handleFormChange('employee_id', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth 
              
//                sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}>
//                 <InputLabel>Employment Status</InputLabel>
//                 <Select
//                   value={employeeForm.employment_status}
//                   onChange={(e) => handleFormChange('employment_status', e.target.value)}
//                   label="Employment Status"
//                 >
//                   {options.employment_statuses.map(status => (
//                     <MenuItem key={status} value={status}>{status}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="First Name *"
//                 value={employeeForm.first_name}
//                 onChange={(e) => handleFormChange('first_name', e.target.value)}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Last Name *"
//                 value={employeeForm.last_name}
//                 onChange={(e) => handleFormChange('last_name', e.target.value)}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Email"
//                 type="email"
//                 value={employeeForm.email}
//                 onChange={(e) => handleFormChange('email', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Phone"
//                 value={employeeForm.phone_number}
//                 onChange={(e) => handleFormChange('phone_number', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Date of Birth *"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={employeeForm.date_of_birth}
//                 onChange={(e) => handleFormChange('date_of_birth', e.target.value)}
//                 required
//                 error={employeeForm.date_of_birth && !validateAge(employeeForm.date_of_birth)}
//                 helperText={
//                   employeeForm.date_of_birth && !validateAge(employeeForm.date_of_birth) 
//                     ? `Employee must be 12 years or older. Current age would be ${calculateAge(employeeForm.date_of_birth)} years.`
//                     : "Employee must be 12 years or older"
//                 }
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth 
//                sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   value={employeeForm.gender}
//                   onChange={(e) => handleFormChange('gender', e.target.value)}
//                   label="Gender"
//                 >
//                   <MenuItem value="">Select Gender</MenuItem>
//                   {options.genders.map(gender => (
//                     <MenuItem key={gender} value={gender}>{gender}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="National ID"
//                 value={employeeForm.national_id}
//                 onChange={(e) => handleFormChange('national_id', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         );

//       case 1: // Employment Details
//         return (
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth 
//                sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}>
//                 <InputLabel>Job Title</InputLabel>
//                 <Select
//                   value={employeeForm.job_title}
//                   onChange={(e) => handleFormChange('job_title', e.target.value)}
//                   label="Job Title"
//                 >
//                   <MenuItem value="">Select Job Title</MenuItem>
//                   {options.positions.map(position => (
//                     <MenuItem key={position} value={position}>{position}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth 
//                sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}>
//                 <InputLabel>Department</InputLabel>
//                 <Select
//                   value={employeeForm.department}
//                   onChange={(e) => handleFormChange('department', e.target.value)}
//                   label="Department"
//                 >
//                   <MenuItem value="">Select Department</MenuItem>
//                   {options.departments.map(dept => (
//                     <MenuItem key={dept} value={dept}>{dept}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth
              
//                sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}>
//                 <InputLabel>Employment Type</InputLabel>
//                 <Select
//                   value={employeeForm.employment_type}
//                   onChange={(e) => handleFormChange('employment_type', e.target.value)}
//                   label="Employment Type"
//                 >
//                   <MenuItem value="">Select Employment Type</MenuItem>
//                   {options.employment_types.map(type => (
//                     <MenuItem key={type} value={type}>{type}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Hire Date"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={employeeForm.hire_date}
//                 onChange={(e) => handleFormChange('hire_date', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Salary"
//                 type="number"
//                 value={employeeForm.salary}
//                 onChange={(e) => handleFormChange('salary', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth
//                sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}
//               >
//                 <InputLabel>Shift</InputLabel>
//                 <Select
//                   value={employeeForm.shift}
//                   onChange={(e) => handleFormChange('shift', e.target.value)}
//                   label="Shift"
//                 >
//                   <MenuItem value="">Select Shift</MenuItem>
//                   {options.shifts.map(shift => (
//                     <MenuItem key={shift} value={shift}>{shift}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth 
//                sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}
//               >
//                 <InputLabel>Work Schedule</InputLabel>
//                 <Select
//                   value={employeeForm.work_schedule}
//                   onChange={(e) => handleFormChange('work_schedule', e.target.value)}
//                   label="Work Schedule"
//                 >
//                   <MenuItem value="">Select Work Schedule</MenuItem>
//                   {options.work_schedules.map(schedule => (
//                     <MenuItem key={schedule} value={schedule}>{schedule}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Supervisor Name"
//                 value={employeeForm.supervisor_name}
//                 onChange={(e) => handleFormChange('supervisor_name', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         );

//       case 2: // Address & Contact
//         return (
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Address Line 1"
//                 value={employeeForm.address_line1}
//                 onChange={(e) => handleFormChange('address_line1', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Address Line 2"
//                 value={employeeForm.address_line2}
//                 onChange={(e) => handleFormChange('address_line2', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="City"
//                 value={employeeForm.city}
//                 onChange={(e) => handleFormChange('city', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="State"
//                 value={employeeForm.state}
//                 onChange={(e) => handleFormChange('state', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Postal Code"
//                 value={employeeForm.postal_code}
//                 onChange={(e) => handleFormChange('postal_code', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Country"
//                 value={employeeForm.country}
//                 onChange={(e) => handleFormChange('country', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Emergency Contact Name"
//                 value={employeeForm.emergency_contact_name}
//                 onChange={(e) => handleFormChange('emergency_contact_name', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Emergency Contact Phone"
//                 value={employeeForm.emergency_contact_phone}
//                 onChange={(e) => handleFormChange('emergency_contact_phone', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Emergency Contact Relationship"
//                 value={employeeForm.emergency_contact_relationship}
//                 onChange={(e) => handleFormChange('emergency_contact_relationship', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         );

//       case 3: // Additional Info
//         return (
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Bank Name"
//                 value={employeeForm.bank_name}
//                 onChange={(e) => handleFormChange('bank_name', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Bank Account Number"
//                 value={employeeForm.bank_account_number}
//                 onChange={(e) => handleFormChange('bank_account_number', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Bank Routing Number"
//                 value={employeeForm.bank_routing_number}
//                 onChange={(e) => handleFormChange('bank_routing_number', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Education Level"
//                 value={employeeForm.education_level}
//                 onChange={(e) => handleFormChange('education_level', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Qualifications"
//                 multiline
//                 rows={2}
//                 value={employeeForm.qualifications}
//                 onChange={(e) => handleFormChange('qualifications', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Certifications"
//                 multiline
//                 rows={2}
//                 value={employeeForm.certifications}
//                 onChange={(e) => handleFormChange('certifications', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Notes"
//                 multiline
//                 rows={3}
//                 value={employeeForm.notes}
//                 onChange={(e) => handleFormChange('notes', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'primary.dark' }}>
//         <Toolbar>
//           <PeopleIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Employee Management
//           </Typography>
//           <Chip 
//             label={`${employees.length} Employees`} 
//             color="secondary" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={() => setOpenCreateDialog(true)}
//             sx={{ borderRadius: 2, backgroundColor: 'success.main' }}
//           >
//             New Employee
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: 'primary.light' }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search employees by ID, name, email, department..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     color="primary"
//                   >
//                     Filters
//                   </Button>
//                   <Button onClick={resetFilters} variant="outlined" size="small" color="primary">
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth 
//                      sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}
//                     >
//                       <InputLabel>Department</InputLabel>
//                       <Select
//                         value={filters.department}
//                         onChange={(e) => handleFilterChange('department', e.target.value)}
//                         label="Department"
//                       >
//                         <MenuItem value="">All Departments</MenuItem>
//                         {options.departments.map(dept => (
//                           <MenuItem key={dept} value={dept}>{dept}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth 
//                      sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}
//                     >
//                       <InputLabel>Position</InputLabel>
//                       <Select
//                         value={filters.position}
//                         onChange={(e) => handleFilterChange('position', e.target.value)}
//                         label="Position"
//                       >
//                         <MenuItem value="">All Positions</MenuItem>
//                         {options.positions.map(position => (
//                           <MenuItem key={position} value={position}>{position}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth 
//                      sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}
//                     >
//                       <InputLabel>Status</InputLabel>
//                       <Select
//                         value={filters.employment_status}
//                         onChange={(e) => handleFilterChange('employment_status', e.target.value)}
//                         label="Status"
//                       >
//                         <MenuItem value="">All Status</MenuItem>
//                         {options.employment_statuses.map(status => (
//                           <MenuItem key={status} value={status}>{status}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth 
//                      sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}>
//                       <InputLabel>Employment Type</InputLabel>
//                       <Select
//                         value={filters.employment_type}
//                         onChange={(e) => handleFilterChange('employment_type', e.target.value)}
//                         label="Employment Type"
//                       >
//                         <MenuItem value="">All Types</MenuItem>
//                         {options.employment_types.map(type => (
//                           <MenuItem key={type} value={type}>{type}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
            
            
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="primary" />
//               </Box>
//             ) : filteredEmployees.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'primary.light' }}>
//                 <CardContent>
//                   <PersonIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
//                   <Typography variant="h5" color="primary.main" gutterBottom>
//                     No employees found
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     {employees.length === 0 
//                       ? "Add your first employee to start managing your farm workforce" 
//                       : "No employees match your search criteria"}
//                   </Typography>
//                   {employees.length === 0 && (
//                     <Button 
//                       variant="contained" 
//                       color="primary" 
//                       onClick={() => setOpenCreateDialog(true)} 
//                       size="large"
//                     >
//                       Add First Employee
//                     </Button>
//                   )}
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'primary.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredEmployees}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Create Employee Dialog */}
//       <Dialog 
//         open={openCreateDialog} 
//         onClose={() => {
//           setOpenCreateDialog(false);
//           resetForm();
//           setActiveTab(0);
//         }}
//         maxWidth="md"
//         fullWidth
//         scroll="paper"
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <AddIcon sx={{ mr: 1 }} />
//             Add New Employee
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} sx={{ mb: 2 }}>
//             <Tab label="Basic Info" />
//             <Tab label="Employment" />
//             <Tab label="Address & Contact" />
//             <Tab label="Additional Info" />
//           </Tabs>
//           {renderFormTabContent()}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => {
//             setOpenCreateDialog(false);
//             resetForm();
//             setActiveTab(0);
//           }}>Cancel</Button>
//           <Button 
//             onClick={handleCreateEmployee} 
//             variant="contained" 
//             color="success"
//             disabled={!employeeForm.first_name || !employeeForm.last_name || !employeeForm.date_of_birth || !validateAge(employeeForm.date_of_birth)}
//           >
//             Create Employee
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Employee Dialog */}
//       <Dialog 
//         open={openEditDialog} 
//         onClose={() => {
//           setOpenEditDialog(false);
//           resetForm();
//           setActiveTab(0);
//         }}
//         maxWidth="md"
//         fullWidth
//         scroll="paper"
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <EditIcon sx={{ mr: 1 }} />
//             Edit Employee - {selectedEmployee?.full_name}
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} sx={{ mb: 2 }}>
//             <Tab label="Basic Info" />
//             <Tab label="Employment" />
//             <Tab label="Address & Contact" />
//             <Tab label="Additional Info" />
//           </Tabs>
//           {renderFormTabContent()}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => {
//             setOpenEditDialog(false);
//             resetForm();
//             setActiveTab(0);
//           }}>Cancel</Button>
//           <Button 
//             onClick={handleUpdateEmployee} 
//             variant="contained" 
//             color="primary"
//             disabled={!employeeForm.first_name || !employeeForm.last_name || !employeeForm.date_of_birth || !validateAge(employeeForm.date_of_birth)}
//           >
//             Update Employee
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* View Employee Dialog */}
//       <Dialog 
//         open={openViewDialog} 
//         onClose={() => setOpenViewDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <PersonIcon sx={{ mr: 1 }} />
//               Employee Details - {selectedEmployee?.full_name}
//             </Box>
//             <IconButton onClick={() => setOpenViewDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedEmployee && (
//             <Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                 {generateAvatar(selectedEmployee)}
//                 <Box sx={{ ml: 2 }}>
//                   <Typography variant="h5" fontWeight="bold">
//                     {selectedEmployee.full_name}
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary">
//                     {selectedEmployee.employee_id || 'No Employee ID'}
//                   </Typography>
//                 </Box>
//                 <Chip 
//                   label={selectedEmployee.employment_status} 
//                   color={getStatusColor(selectedEmployee.employment_status)}
//                   sx={{ ml: 'auto' }}
//                 />
//               </Box>

//               <Grid container spacing={3}>
//                 <Grid item xs={12} sm={6}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
//                         <PersonIcon sx={{ mr: 1 }} />
//                         Personal Information
//                       </Typography>
//                       <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                         <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} />
//                         <Typography variant="body2">{selectedEmployee.email || 'N/A'}</Typography>
//                       </Box>
//                       <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                         <PhoneIcon sx={{ mr: 1, color: 'text.secondary' }} />
//                         <Typography variant="body2">{selectedEmployee.phone_number || 'N/A'}</Typography>
//                       </Box>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         <strong>Gender:</strong> {selectedEmployee.gender || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         <strong>Date of Birth:</strong> {formatDate(selectedEmployee.date_of_birth)}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Age:</strong> {selectedEmployee.date_of_birth && selectedEmployee.date_of_birth !== 'N/A' ? calculateAge(selectedEmployee.date_of_birth) + ' years' : 'N/A'}
//                       </Typography>
//                       <Typography variant="body2" sx={{ mt: 1 }}>
//                         <strong>National ID:</strong> {selectedEmployee.national_id || 'N/A'}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
//                         <WorkIcon sx={{ mr: 1 }} />
//                         Employment Details
//                       </Typography>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         <strong>Department:</strong> {selectedEmployee.department || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         <strong>Position:</strong> {selectedEmployee.job_title || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         <strong>Employment Type:</strong> {selectedEmployee.employment_type || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         <strong>Hire Date:</strong> {formatDate(selectedEmployee.hire_date)}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Salary:</strong> {selectedEmployee.salary || 'N/A'}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>

//                 {selectedEmployee.address_line1 && selectedEmployee.address_line1 !== 'N/A' && (
//                   <Grid item xs={12}>
//                     <Card variant="outlined">
//                       <CardContent>
//                         <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
//                           <LocationIcon sx={{ mr: 1 }} />
//                           Address Information
//                         </Typography>
//                         <Typography variant="body2" sx={{ mb: 1 }}>
//                           {selectedEmployee.address_line1}
//                         </Typography>
//                         {selectedEmployee.address_line2 && selectedEmployee.address_line2 !== 'N/A' && (
//                           <Typography variant="body2" sx={{ mb: 1 }}>
//                             {selectedEmployee.address_line2}
//                           </Typography>
//                         )}
//                         <Typography variant="body2">
//                           {selectedEmployee.city && selectedEmployee.city !== 'N/A' && `${selectedEmployee.city}, `}
//                           {selectedEmployee.state && selectedEmployee.state !== 'N/A' && `${selectedEmployee.state} `}
//                           {selectedEmployee.postal_code && selectedEmployee.postal_code !== 'N/A' && selectedEmployee.postal_code}
//                         </Typography>
//                         {selectedEmployee.country && selectedEmployee.country !== 'N/A' && (
//                           <Typography variant="body2">
//                             {selectedEmployee.country}
//                           </Typography>
//                         )}
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//           {selectedEmployee && (
//             <Button 
//               onClick={() => {
//                 setOpenViewDialog(false);
//                 handleEdit(selectedEmployee);
//               }}
//               variant="contained"
//               color="primary"
//             >
//               Edit
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>

//       {/* Add FAB for mobile */}
//       <Fab
//         color="primary"
//         aria-label="add"
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' }
//         }}
//         onClick={() => setOpenCreateDialog(true)}
//       >
//         <AddIcon />
//       </Fab>
//     </Box>
//   );
// };

// export default EmployeesPage;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Avatar,
  Tabs,
  Tab,
  TableContainer,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  People as PeopleIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  Person as PersonIcon,
  Work as WorkIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  AccountBalance as BankIcon,
  School as EducationIcon,
  Event as DateIcon,
  AttachMoney as MoneyIcon,
} from "@mui/icons-material";
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const EmployeesPage = () => {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState({
    departments: [],
    positions: [],
    employment_statuses: [],
    employment_types: [],
    genders: [],
    shifts: [],
    work_schedules: []
  });
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    department: "",
    position: "",
    employment_status: "",
    employment_type: ""
  });

  // Dialogs
  const [showFilters, setShowFilters] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  // Form Data
  const [employeeForm, setEmployeeForm] = useState({
    employee_id: "",
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    date_of_birth: "",
    gender: "",
    national_id: "",
    job_title: "",
    department: "",
    employment_type: "Full-time",
    employment_status: "Active",
    hire_date: "",
    salary: "",
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    emergency_contact_name: "",
    emergency_contact_phone: "",
    emergency_contact_relationship: "",
    bank_name: "",
    bank_account_number: "",
    bank_routing_number: "",
    education_level: "",
    qualifications: "",
    certifications: "",
    work_schedule: "",
    shift: "",
    performance_rating: "",
    last_performance_review: "",
    next_review_date: "",
    vacation_days_remaining: "",
    sick_days_remaining: "",
    personal_days_remaining: "",
    supervisor_name: "",
    notes: ""
  });

  // Table Columns for Virtualized Table - Removed department and salary columns
  const columns = [
    { width: 60, label: 'Avatar', dataKey: 'avatar' },
    { width: 120, label: 'Employee ID', dataKey: 'employee_id' },
    { width: 150, label: 'Full Name', dataKey: 'full_name' },
    { width: 150, label: 'Email', dataKey: 'email' },
    { width: 120, label: 'Phone', dataKey: 'phone_number' },
    { width: 120, label: 'Position', dataKey: 'job_title' },
    { width: 120, label: 'Status', dataKey: 'employment_status' },
    { width: 150, label: 'Actions', dataKey: 'actions' },
  ];

  const API_URL = "https://dairy.server.statify.co.ke/api/employees";

  // Helper function to calculate age from date of birth
  const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return 0;
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age;
  };

  // Helper function to validate age (must be 12 years and above)
  const validateAge = (dateOfBirth) => {
    const age = calculateAge(dateOfBirth);
    return age >= 12;
  };

  // Helper function to sanitize form data before sending to backend
  const sanitizeFormData = (data) => {
    const sanitized = {};
    
    // Process each field individually
    Object.keys(data).forEach(key => {
      let value = data[key];
      
      // Convert empty strings, "None", "N/A" to null
      if (value === "" || value === "None" || value === "N/A") {
        value = null;
      }
      
      // Handle date fields specifically
      const dateFields = ['date_of_birth', 'hire_date', 'last_performance_review', 'next_review_date'];
      if (dateFields.includes(key)) {
        if (value) {
          try {
            const date = new Date(value);
            if (!isNaN(date.getTime())) {
              sanitized[key] = date.toISOString().split('T')[0]; // YYYY-MM-DD format
            } else {
              sanitized[key] = null;
            }
          } catch {
            sanitized[key] = null;
          }
        } else {
          sanitized[key] = null;
        }
      }
      // Handle number fields
      else if (['salary', 'performance_rating', 'vacation_days_remaining', 'sick_days_remaining', 'personal_days_remaining'].includes(key)) {
        if (value && !isNaN(parseFloat(value))) {
          sanitized[key] = parseFloat(value);
        } else {
          sanitized[key] = null;
        }
      }
      // Handle all other fields
      else {
        sanitized[key] = value;
      }
    });

    return sanitized;
  };

  // Fetch Employees
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      
      if (data && Array.isArray(data.employees)) {
        // Transform data to include full name and formatted values
        const transformedEmployees = data.employees.map(employee => ({
          ...employee,
          full_name: `${employee.first_name} ${employee.last_name}`,
          salary: employee.salary ? `$${parseFloat(employee.salary).toLocaleString()}` : 'N/A',
          hire_date: employee.hire_date ? new Date(employee.hire_date).toLocaleDateString() : 'N/A',
          date_of_birth: employee.date_of_birth ? new Date(employee.date_of_birth).toLocaleDateString() : 'N/A',
          avatar_color: getAvatarColor(employee.first_name),
          phone_number: employee.phone_number || 'N/A',
          email: employee.email || 'N/A',
          department: employee.department || 'N/A',
          job_title: employee.job_title || 'N/A',
          employment_status: employee.employment_status || 'Active'
        }));
        setEmployees(transformedEmployees);
        setFilteredEmployees(transformedEmployees);
      } else {
        setEmployees([]);
        setFilteredEmployees([]);
      }
    } catch (err) {
      console.error('Error fetching employees:', err);
      swal("Error", "Failed to fetch employees", "error");
      setEmployees([]);
      setFilteredEmployees([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Options
  const fetchOptions = async () => {
    try {
      const res = await fetch(`${API_URL}/options`);
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      const data = await res.json();
      if (data) {
        setOptions(data);
      } else {
        throw new Error('No data received');
      }
    } catch (err) {
      console.error('Error fetching options:', err);
      // Use comprehensive default options
      setOptions({
        departments: [
          "Milking Department", "Dairy Operations", "Animal Husbandry", 
          "Feed & Nutrition", "Veterinary Services", "Breeding & Genetics",
          "Quality Assurance", "Processing & Packaging", "Maintenance & Engineering",
          "Logistics & Distribution", "Human Resources", "Finance & Administration",
          "Procurement", "Sales & Marketing", "Health, Safety & Environment", 
          "IT & Data Management"
        ],
        positions: [
          // Operations & Production
          "Chief Dairy Officer", "Dairy Farm Manager", "Assistant Dairy Manager",
          "Milking Supervisor", "Senior Milker", "Milker", "Junior Milker",
          "Milking Technician", "Processing Supervisor", "Pasteurization Operator",
          "Packaging Operator", "Quality Control Technician",
          // Animal Husbandry & Vet
          "Herd Manager", "Livestock Supervisor", "Veterinarian", "Veterinary Assistant",
          "Animal Health Technician", "Feed Supervisor", "Nutrition Specialist",
          "Breeding Officer", "Artificial Insemination Technician",
          // Maintenance & Logistics
          "Maintenance Engineer", "Equipment Technician", "Electrician", "Plumber",
          "Logistics Officer", "Transport Coordinator", "Driver", "Warehouse Clerk",
          // Admin & Support
          "HR Manager", "HR Assistant", "Finance Manager", "Accountant",
          "Procurement Officer", "Inventory Clerk", "Administrative Assistant",
          "IT Officer", "Data Analyst", "Safety Officer", "Marketing Officer",
          "Sales Representative"
        ],
        employment_statuses: ["Active", "Inactive"],
        employment_types: ["Full-time", "Part-time", "Contract", "Seasonal"],
        genders: ["Male", "Female", "Other"],
        shifts: ["Morning Shift", "Afternoon Shift", "Evening Shift", "Night Shift", "Rotating Shift"],
        work_schedules: ["5-day week", "6-day week", "Rotating", "Flexible"]
      });
    }
  };

  useEffect(() => {
    fetchEmployees();
    fetchOptions();
  }, []);

  // Filter employees based on search and filters
  useEffect(() => {
    if (!Array.isArray(employees)) {
      setFilteredEmployees([]);
      return;
    }
    
    let results = employees;

    // Apply search term
    if (searchTerm) {
      results = results.filter(employee =>
        (employee.employee_id?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (employee.first_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (employee.last_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (employee.email?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (employee.department?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (employee.job_title?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (employee.phone_number?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    // Apply filters
    if (filters.department) {
      results = results.filter(employee => 
        employee.department === filters.department
      );
    }

    if (filters.position) {
      results = results.filter(employee => 
        employee.job_title === filters.position
      );
    }

    if (filters.employment_status) {
      results = results.filter(employee => 
        employee.employment_status === filters.employment_status
      );
    }

    if (filters.employment_type) {
      results = results.filter(employee => 
        employee.employment_type === filters.employment_type
      );
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortConfig.direction === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredEmployees(results);
  }, [employees, searchTerm, filters, sortConfig]);

  // Sort Handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter Handlers
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      department: "",
      position: "",
      employment_status: "",
      employment_type: ""
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
  };

  // Form Handlers
  const handleFormChange = (field, value) => {
    setEmployeeForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setEmployeeForm({
      employee_id: "",
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      date_of_birth: "",
      gender: "",
      national_id: "",
      job_title: "",
      department: "",
      employment_type: "Full-time",
      employment_status: "Active",
      hire_date: "",
      salary: "",
      address_line1: "",
      address_line2: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
      emergency_contact_name: "",
      emergency_contact_phone: "",
      emergency_contact_relationship: "",
      bank_name: "",
      bank_account_number: "",
      bank_routing_number: "",
      education_level: "",
      qualifications: "",
      certifications: "",
      work_schedule: "",
      shift: "",
      performance_rating: "",
      last_performance_review: "",
      next_review_date: "",
      vacation_days_remaining: "",
      sick_days_remaining: "",
      personal_days_remaining: "",
      supervisor_name: "",
      notes: ""
    });
  };

  // Create Employee
  const handleCreateEmployee = async () => {
    // Validation
    if (!employeeForm.first_name || !employeeForm.last_name) {
      swal("Error", "First name and last name are required", "error");
      return;
    }

    // Age validation - must be 12 years and above
    if (employeeForm.date_of_birth) {
      const age = calculateAge(employeeForm.date_of_birth);
      if (age < 12) {
        swal("Error", "Employee must be 12 years or older. Current age would be " + age + " years.", "error");
        return;
      }
    }

    try {
      const sanitizedData = sanitizeFormData(employeeForm);
      console.log("Sending data:", sanitizedData); // Debug log
      
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(sanitizedData),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Employee created successfully!", "success");
        setOpenCreateDialog(false);
        resetForm();
        setActiveTab(0);
        fetchEmployees();
      } else {
        swal("Error", data.error || "Failed to create employee", "error");
      }
    } catch (err) {
      console.error("Create employee error:", err);
      swal("Error", "Something went wrong", "error");
    }
  };

  // Update Employee
  const handleUpdateEmployee = async () => {
    if (!selectedEmployee) return;

    // Age validation - must be 12 years and above
    if (employeeForm.date_of_birth) {
      const age = calculateAge(employeeForm.date_of_birth);
      if (age < 12) {
        swal("Error", "Employee must be 12 years or older. Current age would be " + age + " years.", "error");
        return;
      }
    }

    try {
      const sanitizedData = sanitizeFormData(employeeForm);
      console.log("Updating data:", sanitizedData); // Debug log
      
      const res = await fetch(`${API_URL}/${selectedEmployee.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(sanitizedData),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Employee updated successfully!", "success");
        setOpenEditDialog(false);
        setSelectedEmployee(null);
        resetForm();
        setActiveTab(0);
        fetchEmployees();
      } else {
        swal("Error", data.error || "Failed to update employee", "error");
      }
    } catch (err) {
      console.error("Update employee error:", err);
      swal("Error", "Something went wrong", "error");
    }
  };

  // Delete Handler
  const handleDelete = async (employeeId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the employee record!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${employeeId}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          fetchEmployees();
        } else {
          swal("Error", data.error || "Failed to delete employee", "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // View Employee Details
  const handleViewDetails = (employee) => {
    setSelectedEmployee(employee);
    setOpenViewDialog(true);
  };

  // Format date for form input (YYYY-MM-DD)
  const formatDateForInput = (dateString) => {
    if (!dateString || dateString === 'N/A') return "";
    try {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    } catch {
      return "";
    }
  };

  // Open Edit Dialog
  const handleEdit = (employee) => {
    setSelectedEmployee(employee);
    setEmployeeForm({
      employee_id: employee.employee_id || "",
      first_name: employee.first_name || "",
      last_name: employee.last_name || "",
      email: employee.email || "",
      phone_number: employee.phone_number || "",
      date_of_birth: formatDateForInput(employee.date_of_birth),
      gender: employee.gender || "",
      national_id: employee.national_id || "",
      job_title: employee.job_title || "",
      department: employee.department || "",
      employment_type: employee.employment_type || "Full-time",
      employment_status: employee.employment_status || "Active",
      hire_date: formatDateForInput(employee.hire_date),
      salary: employee.salary ? employee.salary.replace('$', '').replace(/,/g, '') : "",
      address_line1: employee.address_line1 || "",
      address_line2: employee.address_line2 || "",
      city: employee.city || "",
      state: employee.state || "",
      postal_code: employee.postal_code || "",
      country: employee.country || "",
      emergency_contact_name: employee.emergency_contact_name || "",
      emergency_contact_phone: employee.emergency_contact_phone || "",
      emergency_contact_relationship: employee.emergency_contact_relationship || "",
      bank_name: employee.bank_name || "",
      bank_account_number: employee.bank_account_number || "",
      bank_routing_number: employee.bank_routing_number || "",
      education_level: employee.education_level || "",
      qualifications: employee.qualifications || "",
      certifications: employee.certifications || "",
      work_schedule: employee.work_schedule || "",
      shift: employee.shift || "",
      performance_rating: employee.performance_rating || "",
      last_performance_review: formatDateForInput(employee.last_performance_review),
      next_review_date: formatDateForInput(employee.next_review_date),
      vacation_days_remaining: employee.vacation_days_remaining || "",
      sick_days_remaining: employee.sick_days_remaining || "",
      personal_days_remaining: employee.personal_days_remaining || "",
      supervisor_name: employee.supervisor_name || "",
      notes: employee.notes || ""
    });
    setOpenEditDialog(true);
  };

  // Get Status Color
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active': return 'success';
      case 'inactive': return 'warning';
      case 'terminated': return 'error';
      case 'retired': return 'secondary';
      case 'suspended': return 'error';
      case 'probation': return 'warning';
      default: return 'default';
    }
  };

  // Get Avatar Color
  const getAvatarColor = (name) => {
    const colors = [
      '#024A59', '#FFA916', '#9c27b0', '#673ab7', '#3f51b5',
      '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50',
      '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800'
    ];
    const index = name ? name.charCodeAt(0) % colors.length : 0;
    return colors[index];
  };

  // Generate Avatar
  const generateAvatar = (employee) => {
    const initials = `${employee.first_name?.[0] || ''}${employee.last_name?.[0] || ''}`.toUpperCase();
    return (
      <Avatar
        sx={{
          bgcolor: employee.avatar_color || getAvatarColor(employee.first_name),
          width: 32,
          height: 32,
          fontSize: '0.875rem'
        }}
      >
        {initials}
      </Avatar>
    );
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString || dateString === 'N/A') return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString();
    } catch {
      return dateString;
    }
  };

  // Virtualized Table Content
  const fixedHeaderContent = () => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: '#024A59', 
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          <TableSortLabel
            active={sortConfig.key === column.dataKey}
            direction={sortConfig.direction}
            onClick={() => handleSort(column.dataKey)}
            sx={{ color: 'white !important' }}
          >
            {column.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );

  const rowContent = (index, employee) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        {generateAvatar(employee)}
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {employee.employee_id || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {employee.full_name}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {employee.email}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {employee.phone_number}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {employee.job_title}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={employee.employment_status} 
          size="small"
          color={getStatusColor(employee.employment_status)}
          sx={{ fontSize: '0.7rem', height: '24px' }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: '#024A59'
            }}
            onClick={() => handleViewDetails(employee)}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: '#024A59'
            }}
            onClick={() => handleEdit(employee)}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: '#d32f2f'
            }}
            onClick={() => handleDelete(employee.id)}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </React.Fragment>
  );

  // Form Tabs Content
  const renderFormTabContent = () => {
    switch (activeTab) {
      case 0: // Basic Info
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Employee ID"
                value={employeeForm.employee_id}
                onChange={(e) => handleFormChange('employee_id', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Employment Status</InputLabel>
                <Select
                  value={employeeForm.employment_status}
                  onChange={(e) => handleFormChange('employment_status', e.target.value)}
                  label="Employment Status"
                >
                  {options.employment_statuses.map(status => (
                    <MenuItem key={status} value={status}>{status}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name *"
                value={employeeForm.first_name}
                onChange={(e) => handleFormChange('first_name', e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name *"
                value={employeeForm.last_name}
                onChange={(e) => handleFormChange('last_name', e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={employeeForm.email}
                onChange={(e) => handleFormChange('email', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone"
                value={employeeForm.phone_number}
                onChange={(e) => handleFormChange('phone_number', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Date of Birth *"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={employeeForm.date_of_birth}
                onChange={(e) => handleFormChange('date_of_birth', e.target.value)}
                required
                error={employeeForm.date_of_birth && !validateAge(employeeForm.date_of_birth)}
                helperText={
                  employeeForm.date_of_birth && !validateAge(employeeForm.date_of_birth) 
                    ? `Employee must be 12 years or older. Current age would be ${calculateAge(employeeForm.date_of_birth)} years.`
                    : "Employee must be 12 years or older"
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Gender</InputLabel>
                <Select
                  value={employeeForm.gender}
                  onChange={(e) => handleFormChange('gender', e.target.value)}
                  label="Gender"
                >
                  <MenuItem value="">Select Gender</MenuItem>
                  {options.genders.map(gender => (
                    <MenuItem key={gender} value={gender}>{gender}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="National ID"
                value={employeeForm.national_id}
                onChange={(e) => handleFormChange('national_id', e.target.value)}
              />
            </Grid>
          </Grid>
        );

      case 1: // Employment Details
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Job Title</InputLabel>
                <Select
                  value={employeeForm.job_title}
                  onChange={(e) => handleFormChange('job_title', e.target.value)}
                  label="Job Title"
                >
                  <MenuItem value="">Select Job Title</MenuItem>
                  {options.positions.map(position => (
                    <MenuItem key={position} value={position}>{position}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Department</InputLabel>
                <Select
                  value={employeeForm.department}
                  onChange={(e) => handleFormChange('department', e.target.value)}
                  label="Department"
                >
                  <MenuItem value="">Select Department</MenuItem>
                  {options.departments.map(dept => (
                    <MenuItem key={dept} value={dept}>{dept}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Employment Type</InputLabel>
                <Select
                  value={employeeForm.employment_type}
                  onChange={(e) => handleFormChange('employment_type', e.target.value)}
                  label="Employment Type"
                >
                  <MenuItem value="">Select Employment Type</MenuItem>
                  {options.employment_types.map(type => (
                    <MenuItem key={type} value={type}>{type}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Hire Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={employeeForm.hire_date}
                onChange={(e) => handleFormChange('hire_date', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Salary"
                type="number"
                value={employeeForm.salary}
                onChange={(e) => handleFormChange('salary', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Shift</InputLabel>
                <Select
                  value={employeeForm.shift}
                  onChange={(e) => handleFormChange('shift', e.target.value)}
                  label="Shift"
                >
                  <MenuItem value="">Select Shift</MenuItem>
                  {options.shifts.map(shift => (
                    <MenuItem key={shift} value={shift}>{shift}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                <InputLabel>Work Schedule</InputLabel>
                <Select
                  value={employeeForm.work_schedule}
                  onChange={(e) => handleFormChange('work_schedule', e.target.value)}
                  label="Work Schedule"
                >
                  <MenuItem value="">Select Work Schedule</MenuItem>
                  {options.work_schedules.map(schedule => (
                    <MenuItem key={schedule} value={schedule}>{schedule}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Supervisor Name"
                value={employeeForm.supervisor_name}
                onChange={(e) => handleFormChange('supervisor_name', e.target.value)}
              />
            </Grid>
          </Grid>
        );

      case 2: // Address & Contact
        return (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address Line 1"
                value={employeeForm.address_line1}
                onChange={(e) => handleFormChange('address_line1', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address Line 2"
                value={employeeForm.address_line2}
                onChange={(e) => handleFormChange('address_line2', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="City"
                value={employeeForm.city}
                onChange={(e) => handleFormChange('city', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="State"
                value={employeeForm.state}
                onChange={(e) => handleFormChange('state', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Postal Code"
                value={employeeForm.postal_code}
                onChange={(e) => handleFormChange('postal_code', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Country"
                value={employeeForm.country}
                onChange={(e) => handleFormChange('country', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Emergency Contact Name"
                value={employeeForm.emergency_contact_name}
                onChange={(e) => handleFormChange('emergency_contact_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Emergency Contact Phone"
                value={employeeForm.emergency_contact_phone}
                onChange={(e) => handleFormChange('emergency_contact_phone', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Emergency Contact Relationship"
                value={employeeForm.emergency_contact_relationship}
                onChange={(e) => handleFormChange('emergency_contact_relationship', e.target.value)}
              />
            </Grid>
          </Grid>
        );

      case 3: // Additional Info
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Bank Name"
                value={employeeForm.bank_name}
                onChange={(e) => handleFormChange('bank_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Bank Account Number"
                value={employeeForm.bank_account_number}
                onChange={(e) => handleFormChange('bank_account_number', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Bank Routing Number"
                value={employeeForm.bank_routing_number}
                onChange={(e) => handleFormChange('bank_routing_number', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Education Level"
                value={employeeForm.education_level}
                onChange={(e) => handleFormChange('education_level', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Qualifications"
                multiline
                rows={2}
                value={employeeForm.qualifications}
                onChange={(e) => handleFormChange('qualifications', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Certifications"
                multiline
                rows={2}
                value={employeeForm.certifications}
                onChange={(e) => handleFormChange('certifications', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Notes"
                multiline
                rows={3}
                value={employeeForm.notes}
                onChange={(e) => handleFormChange('notes', e.target.value)}
              />
            </Grid>
          </Grid>
        );

      default:
        return null;
    }
  };

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: '#024A59' }}>
        <Toolbar>
          <PeopleIcon sx={{ mr: 2 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Employee Management
          </Typography>
          <Chip 
            label={`${employees.length} Employees`} 
            sx={{ 
              backgroundColor: '#FFA916', 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={() => setOpenCreateDialog(true)}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: '#FFA916',
              '&:hover': {
                backgroundColor: '#e59400',
              }
            }}
          >
            New Employee
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ 
          mb: 3, 
          borderRadius: 2, 
          border: 2, 
          borderColor: '#024A59' 
        }}>
          {/* Search and Filters */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search employees by ID, name, email, department..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="small"
                    sx={{
                      backgroundColor: showFilters ? '#024A59' : 'transparent',
                      color: showFilters ? 'white' : '#024A59',
                      borderColor: '#024A59',
                      '&:hover': {
                        backgroundColor: '#024A59',
                        color: 'white',
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="small" 
                    sx={{
                      color: '#024A59',
                      borderColor: '#024A59',
                      '&:hover': {
                        backgroundColor: '#024A59',
                        color: 'white',
                      }
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                      <InputLabel>Department</InputLabel>
                      <Select
                        value={filters.department}
                        onChange={(e) => handleFilterChange('department', e.target.value)}
                        label="Department"
                      >
                        <MenuItem value="">All Departments</MenuItem>
                        {options.departments.map(dept => (
                          <MenuItem key={dept} value={dept}>{dept}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                      <InputLabel>Position</InputLabel>
                      <Select
                        value={filters.position}
                        onChange={(e) => handleFilterChange('position', e.target.value)}
                        label="Position"
                      >
                        <MenuItem value="">All Positions</MenuItem>
                        {options.positions.map(position => (
                          <MenuItem key={position} value={position}>{position}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={filters.employment_status}
                        onChange={(e) => handleFilterChange('employment_status', e.target.value)}
                        label="Status"
                      >
                        <MenuItem value="">All Status</MenuItem>
                        {options.employment_statuses.map(status => (
                          <MenuItem key={status} value={status}>{status}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth>
                      <InputLabel>Employment Type</InputLabel>
                      <Select
                        value={filters.employment_type}
                        onChange={(e) => handleFilterChange('employment_type', e.target.value)}
                        label="Employment Type"
                      >
                        <MenuItem value="">All Types</MenuItem>
                        {options.employment_types.map(type => (
                          <MenuItem key={type} value={type}>{type}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Content Area */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: '#024A59' }} />
              </Box>
            ) : filteredEmployees.length === 0 ? (
              <Card sx={{ 
                textAlign: 'center', 
                p: 4, 
                border: 2, 
                borderColor: '#024A59' 
              }}>
                <CardContent>
                  <PersonIcon sx={{ fontSize: 64, color: '#024A59', mb: 2 }} />
                  <Typography variant="h5" sx={{ color: '#024A59' }} gutterBottom>
                    No employees found
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    {employees.length === 0 
                      ? "Add your first employee to start managing your farm workforce" 
                      : "No employees match your search criteria"}
                  </Typography>
                  {employees.length === 0 && (
                    <Button 
                      variant="contained" 
                      sx={{ 
                        backgroundColor: '#FFA916',
                        '&:hover': {
                          backgroundColor: '#e59400',
                        }
                      }}
                      onClick={() => setOpenCreateDialog(true)} 
                      size="large"
                    >
                      Add First Employee
                    </Button>
                  )}
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ 
                height: 600, 
                border: 1, 
                borderColor: '#024A59', 
                borderRadius: 1 
              }}>
                <TableVirtuoso
                  data={filteredEmployees}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Create Employee Dialog */}
      <Dialog 
        open={openCreateDialog} 
        onClose={() => {
          setOpenCreateDialog(false);
          resetForm();
          setActiveTab(0);
        }}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle sx={{ backgroundColor: '#024A59', color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <AddIcon sx={{ mr: 1 }} />
            Add New Employee
          </Box>
        </DialogTitle>
        <DialogContent>
          <Tabs 
            value={activeTab} 
            onChange={(e, newValue) => setActiveTab(newValue)} 
            sx={{ mb: 2 }}
            TabIndicatorProps={{
              style: {
                backgroundColor: '#024A59'
              }
            }}
          >
            <Tab label="Basic Info" sx={{ color: '#024A59' }} />
            <Tab label="Employment" sx={{ color: '#024A59' }} />
            <Tab label="Address & Contact" sx={{ color: '#024A59' }} />
            <Tab label="Additional Info" sx={{ color: '#024A59' }} />
          </Tabs>
          {renderFormTabContent()}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setOpenCreateDialog(false);
              resetForm();
              setActiveTab(0);
            }}
            sx={{ color: '#024A59' }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleCreateEmployee} 
            variant="contained" 
            sx={{
              backgroundColor: '#FFA916',
              '&:hover': {
                backgroundColor: '#e59400',
              }
            }}
            disabled={!employeeForm.first_name || !employeeForm.last_name || !employeeForm.date_of_birth || !validateAge(employeeForm.date_of_birth)}
          >
            Create Employee
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Employee Dialog */}
      <Dialog 
        open={openEditDialog} 
        onClose={() => {
          setOpenEditDialog(false);
          resetForm();
          setActiveTab(0);
        }}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle sx={{ backgroundColor: '#024A59', color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <EditIcon sx={{ mr: 1 }} />
            Edit Employee - {selectedEmployee?.full_name}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Tabs 
            value={activeTab} 
            onChange={(e, newValue) => setActiveTab(newValue)} 
            sx={{ mb: 2 }}
            TabIndicatorProps={{
              style: {
                backgroundColor: '#024A59'
              }
            }}
          >
            <Tab label="Basic Info" sx={{ color: '#024A59' }} />
            <Tab label="Employment" sx={{ color: '#024A59' }} />
            <Tab label="Address & Contact" sx={{ color: '#024A59' }} />
            <Tab label="Additional Info" sx={{ color: '#024A59' }} />
          </Tabs>
          {renderFormTabContent()}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setOpenEditDialog(false);
              resetForm();
              setActiveTab(0);
            }}
            sx={{ color: '#024A59' }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleUpdateEmployee} 
            variant="contained" 
            sx={{
              backgroundColor: '#024A59',
              '&:hover': {
                backgroundColor: '#013a46',
              }
            }}
            disabled={!employeeForm.first_name || !employeeForm.last_name || !employeeForm.date_of_birth || !validateAge(employeeForm.date_of_birth)}
          >
            Update Employee
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Employee Dialog */}
      <Dialog 
        open={openViewDialog} 
        onClose={() => setOpenViewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: '#024A59', color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <PersonIcon sx={{ mr: 1 }} />
              Employee Details - {selectedEmployee?.full_name}
            </Box>
            <IconButton 
              onClick={() => setOpenViewDialog(false)}
              sx={{ color: 'white' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedEmployee && (
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                {generateAvatar(selectedEmployee)}
                <Box sx={{ ml: 2 }}>
                  <Typography variant="h5" fontWeight="bold">
                    {selectedEmployee.full_name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {selectedEmployee.employee_id || 'No Employee ID'}
                  </Typography>
                </Box>
                <Chip 
                  label={selectedEmployee.employment_status} 
                  color={getStatusColor(selectedEmployee.employment_status)}
                  sx={{ ml: 'auto' }}
                />
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', color: '#024A59' }}>
                        <PersonIcon sx={{ mr: 1 }} />
                        Personal Information
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <EmailIcon sx={{ mr: 1, color: '#024A59' }} />
                        <Typography variant="body2">{selectedEmployee.email || 'N/A'}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <PhoneIcon sx={{ mr: 1, color: '#024A59' }} />
                        <Typography variant="body2">{selectedEmployee.phone_number || 'N/A'}</Typography>
                      </Box>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        <strong>Gender:</strong> {selectedEmployee.gender || 'N/A'}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        <strong>Date of Birth:</strong> {formatDate(selectedEmployee.date_of_birth)}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Age:</strong> {selectedEmployee.date_of_birth && selectedEmployee.date_of_birth !== 'N/A' ? calculateAge(selectedEmployee.date_of_birth) + ' years' : 'N/A'}
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        <strong>National ID:</strong> {selectedEmployee.national_id || 'N/A'}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', color: '#024A59' }}>
                        <WorkIcon sx={{ mr: 1 }} />
                        Employment Details
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        <strong>Department:</strong> {selectedEmployee.department || 'N/A'}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        <strong>Position:</strong> {selectedEmployee.job_title || 'N/A'}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        <strong>Employment Type:</strong> {selectedEmployee.employment_type || 'N/A'}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        <strong>Hire Date:</strong> {formatDate(selectedEmployee.hire_date)}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Salary:</strong> {selectedEmployee.salary || 'N/A'}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                {selectedEmployee.address_line1 && selectedEmployee.address_line1 !== 'N/A' && (
                  <Grid item xs={12}>
                    <Card variant="outlined">
                      <CardContent>
                        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', color: '#024A59' }}>
                          <LocationIcon sx={{ mr: 1 }} />
                          Address Information
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          {selectedEmployee.address_line1}
                        </Typography>
                        {selectedEmployee.address_line2 && selectedEmployee.address_line2 !== 'N/A' && (
                          <Typography variant="body2" sx={{ mb: 1 }}>
                            {selectedEmployee.address_line2}
                          </Typography>
                        )}
                        <Typography variant="body2">
                          {selectedEmployee.city && selectedEmployee.city !== 'N/A' && `${selectedEmployee.city}, `}
                          {selectedEmployee.state && selectedEmployee.state !== 'N/A' && `${selectedEmployee.state} `}
                          {selectedEmployee.postal_code && selectedEmployee.postal_code !== 'N/A' && selectedEmployee.postal_code}
                        </Typography>
                        {selectedEmployee.country && selectedEmployee.country !== 'N/A' && (
                          <Typography variant="body2">
                            {selectedEmployee.country}
                          </Typography>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                )}
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenViewDialog(false)}
            sx={{ color: '#024A59' }}
          >
            Close
          </Button>
          {selectedEmployee && (
            <Button 
              onClick={() => {
                setOpenViewDialog(false);
                handleEdit(selectedEmployee);
              }}
              variant="contained"
              sx={{
                backgroundColor: '#024A59',
                '&:hover': {
                  backgroundColor: '#013a46',
                }
              }}
            >
              Edit
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Add FAB for mobile */}
      <Fab
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', md: 'none' },
          backgroundColor: '#FFA916',
          '&:hover': {
            backgroundColor: '#e59400',
          }
        }}
        onClick={() => setOpenCreateDialog(true)}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default EmployeesPage;